import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardText } from 'material-ui/Card';
import Card from '@material-ui/core/Card';
import CardHead from '../../../../components/CardHead/CardHead';
import OtherOptionsList from './OtherOptionsList';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../../context/LanguageContext';

import './styles.scss';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  }
}));

const OtherOptions = (props) => {
  const { labels } = useLanguage();
  const otherOptionsLabels = labels.otherOptions || {};
  const [expanded, setExpanded] = useState(true);
  const classes = useStyles();


  if (!props.otherOptions?.entries.length) {
    return null;
  }

  const titleStyle = {
    fontSize: '1rem'
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const rightElement = (
    <IconButton
      className={clsx(classes.expand, {
        [classes.expandOpen]: expanded,
      })}
      onClick={handleExpandClick}
      aria-expanded={expanded}
      aria-label="show more"
    >
      <ExpandMoreIcon />
    </IconButton>
)

  const title = props.title || otherOptionsLabels.TITLE || '';
  const subtitle = props.subtitle || otherOptionsLabels.SUBTITLE || '';

  return (
    <article className="row expanded">
      <Card>
        <CardHead
          title={title}
          subtitle={subtitle}
          headClassName='card-title'
          titleStyle={titleStyle}
          rightElement={rightElement}
        />
        <Collapse in={expanded} timeout="auto">
          <CardText className="card-text">
            <OtherOptionsList
              {...props}
              readOnly={props.readOnly}
            />
          </CardText>
        </Collapse>
      </Card>
    </article>
  );
};

OtherOptions.propTypes = {
  otherOptions: PropTypes.object.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  readOnly: PropTypes.bool,
  onOptionToggled: PropTypes.func
};

OtherOptions.defaultProps = {
  title: '',
  subtitle: '',
  readOnly: false,
  onOptionToggled: null
};

export default OtherOptions;
